import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

/**
 * Drives the singleton contact (person) profile popup. Mirrors ProspectModalService:
 * any view emits a contact key to open the LinkedIn-style profile modal.
 */
@Injectable({ providedIn: 'root' })
export class ContactModalService {
    private openKeySubject = new BehaviorSubject<string | null>(null)
    readonly openKey$ = this.openKeySubject.asObservable()

    open(contactKey: string): void {
        this.openKeySubject.next(contactKey)
    }

    close(): void {
        this.openKeySubject.next(null)
    }
}
